import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=0489902d&scoped=true&"
import script from "./UserProfileView.vue?vue&type=script&lang=ts&"
export * from "./UserProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileView.vue?vue&type=style&index=0&id=0489902d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489902d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VContainer})
